import { useEffect, useState } from "react";
import { defaultPageContent } from "../data/editablePageContent";

function getPageForm(pages, pageKey) {
  const override = pages.find((page) => page.page_key === pageKey);
  if (!override) return defaultPageContent(pageKey);
  return {
    eyebrow: override.eyebrow,
    title: override.title,
    intro: override.intro,
    sections: override.sections,
  };
}

export default function useContentPageForm(pages) {
  const [pageKey, setPageKey] = useState("about");
  const [form, setForm] = useState(defaultPageContent("about"));

  useEffect(() => {
    setForm(getPageForm(pages, pageKey));
  }, [pageKey, pages]);

  const update = (field, value) => {
    setForm((currentForm) => ({ ...currentForm, [field]: value }));
  };

  const updateSection = (index, field, value) => {
    setForm((currentForm) => ({
      ...currentForm,
      sections: currentForm.sections.map((section, sectionIndex) => {
        return sectionIndex === index ? { ...section, [field]: value } : section;
      }),
    }));
  };

  const addSection = () => {
    setForm((currentForm) => ({
      ...currentForm,
      sections: [
        ...currentForm.sections,
        { heading: "New section", body: "Add public-page content here." },
      ],
    }));
  };

  const removeSection = (index) => {
    setForm((currentForm) => ({
      ...currentForm,
      sections: currentForm.sections.filter((_, sectionIndex) => sectionIndex !== index),
    }));
  };

  const resetForm = () => setForm(defaultPageContent(pageKey));
  const hasOverride = pages.some((page) => page.page_key === pageKey);

  return {
    addSection,
    form,
    hasOverride,
    pageKey,
    removeSection,
    resetForm,
    setPageKey,
    update,
    updateSection,
  };
}